import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: `https://api.starguides.co`
  })
}



// WEBPACK FOOTER //
// ./src/api/Api.js